import { AlertSettings, AlertsService } from "@jaspero/ng-alerts";
import { ConfirmSettings, ConfirmationService } from "@systemic/ng-confirmations";
import { NotificationsService } from "angular2-notifications";
import { NotifyType, NotifyTheme } from "../interface/INotification";

export class NotifyGuru {
  private NotyOptions = {
    position: ['top', 'right'],
    timeOut: 5000,
    lastOnBottom: true,
    clickToClose: true,
    showProgressBar: true,
    pauseOnHover: true,
    animate: 'fromRight'
  };
  private AlertOption: AlertSettings = {
    overlay: true,
    overlayClickToClose: false,
    showCloseButton: true,
    duration: 5000
  };
  private ConfirmOptions: ConfirmSettings = {
    overlay: true,
    overlayClickToClose: false,
    showCloseButton: true,
    confirmText: 'Yes',
    declineText: 'No'
  };
  constructor(
    private srvConfirm: ConfirmationService,
    private srvAlert: AlertsService,
    private srvNoty: NotificationsService) {

  }
  show(message: string, typ?: NotifyType, ui?: NotifyTheme) {
    if (typ && typ === NotifyType.success) {
      this.success(message, ui);
    } else if (typ && typ === NotifyType.warning) {
      this.warning(message, ui);
    } else if (typ && typ === NotifyType.error) {
      this.error(message, ui);
    } else {
      this.info(message, ui);
    }
  }
  success(message: string, ui?: NotifyTheme) {
    if (ui && ui === NotifyTheme.alert) {
      this.srvAlert.create('success', message, 'Success', this.AlertOption);
    } else {
      this.srvNoty.success('Success', message, this.NotyOptions);
    }
  }
  error(message: string, ui?: NotifyTheme) {
    if (ui && ui === NotifyTheme.alert) {
      this.srvAlert.create('error', message, 'Error', this.AlertOption);
    } else {
      this.srvNoty.error('Error', message, this.NotyOptions);
    }
  }
  warning(message: string, ui?: NotifyTheme) {
    if (ui && ui === NotifyTheme.alert) {
      this.srvAlert.create('warning', message, 'Warning', this.AlertOption);
    } else {
      this.srvNoty.warn('Warning', message, this.NotyOptions);
    }
  }
  info(message: string, ui?: NotifyTheme) {
    if (ui && ui === NotifyTheme.alert) {
      this.srvAlert.create('info', message, 'Info', this.AlertOption);
    } else {
      this.srvNoty.info('Info', message, this.NotyOptions);
    }
  }
  confirm(str: string, title?: string) {
    title = (title) ? title : 'Are you sure?';
    return this.srvConfirm.create(title, str, this.ConfirmOptions).map(t => t.resolved);
  }
}



// WEBPACK FOOTER //
// E:/GangaJewallery-Final/app.server/systemic.app.server/client/src/main/@systemic/helper/notify.guru.ts